import React, { useState, useMemo } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Header from './components/Header';
import Footer from './components/Footer';
import Login from './pages/Login';
import Home from './pages/Home';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import UserManagement from './pages/UserManagement';
import CDKeyManagement from './pages/CDKeyManagement';
import ResetPassword from './pages/ResetPassword';
import PrivateRoute from './components/PrivateRoute';
import Box from '@mui/material/Box';
import ForgotPassword from './pages/ForgotPassword';
import SMTPConfig from './pages/SMTPConfig';
import ChangePassword from './pages/ChangePassword';
import RemoteTextManagement from './pages/RemoteTextManagement';
import FileServerPage from './pages/FileServerPage';
import FileServerConfigPage from './pages/FileServerConfigPage';
import HomeSettings from './pages/HomeSettings';

export const ColorModeContext = React.createContext({ toggleColorMode: () => {} });
const theme = createTheme();

function App() {
    const location = useLocation();
    const [mode, setMode] = useState('light');
  
    const colorMode = useMemo(
      () => ({
        toggleColorMode: () => {
          setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
        },
      }),
      [],
    );
  
    const theme = useMemo(
        () =>
          createTheme({
            palette: {
              mode,
              ...(mode === 'light'
                ? {
                    // Light mode colors
                    primary: {
                      main: '#1976d2',
                    },
                    secondary: {
                      main: '#dc004e',
                    },
                    background: {
                      default: '#ffffff',
                      paper: '#ffffff',
                    },
                  }
                : {
                    // Dark mode colors
                    primary: {
                      main: '#90caf9',
                    },
                    secondary: {
                      main: '#f48fb1',
                    },
                    background: {
                      default: '#303030',
                      paper: '#424242',
                    },
                    text: {
                      primary: '#ffffff',
                      secondary: 'rgba(255, 255, 255, 0.7)',
                    },
                  }),
            },
          }),
        [mode],
      );
  
    return (
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Box sx={{ display: 'flex' }}>
            {(location.pathname !== '/login' && location.pathname !== '/register' && location.pathname !== '/forgot-password' && location.pathname !== '/reset-password' && location.pathname !== '/') && <Header />}
            <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
              <Routes>
            {/* Set Home as the default page */}
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/users" element={<PrivateRoute><UserManagement /></PrivateRoute>} />
            <Route path="/cdkeys" element={<PrivateRoute><CDKeyManagement /></PrivateRoute>} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/smtp-config" element={<PrivateRoute><SMTPConfig /></PrivateRoute>} />
            <Route path="/change-password" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
            <Route path="/remote-text" element={<PrivateRoute><RemoteTextManagement /></PrivateRoute>} />
            <Route path="/file-server" element={<PrivateRoute><FileServerPage /></PrivateRoute>} />
            <Route path="/file-server-config" element={<PrivateRoute><FileServerConfigPage /></PrivateRoute>} />
            <Route path="/home-settings" element={<PrivateRoute><HomeSettings /></PrivateRoute>} />
            </Routes>
          </Box>
        </Box>
        {location.pathname !== '/' && <Footer />}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
